// 超链接配置
export const linkDefault = {
  isLink: false,
  linkTarget: '_blank',
  linkHref: 'http://www.xxx.com'
}

export const linkConfig = [
  {
    info: {
      title: '超链接设置',
      icon: 'icon-setting'
    },
    fields: [
      { title: '开启', name: 'isLink', type: 'switch' },
      {
        title: '打开方式',
        name: 'linkTarget',
        type: 'select',
        options: [
          {
            value: '_self',
            label: '当前窗口'
          },
          {
            value: '_blank',
            label: '新窗口'
          }
        ],
        visible: ({ isLink }) => !!isLink
      },
      { title: '超链地址', name: 'linkHref', type: 'input', visible: ({ isLink }) => !!isLink }
    ]
  }
]
